module.exports = __webpack_public_path__ + "img/gold-dark.be99a354.png";